module.exports = __webpack_public_path__ + "34a6eab9d70dbf06ff43503327435ded.jpg";